import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-668d0658")

_pushScopeId("data-v-668d0658")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = { class: "left-container" }
const _hoisted_6 = { class: "right-container" }
const _hoisted_7 = { class: "right-top" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "减重", -1)
const _hoisted_9 = { class: "right-top-weight" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "KG", -1)
const _hoisted_11 = { class: "right-middle" }
const _hoisted_12 = { class: "right-bottom" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "right-action" }, [
  /*#__PURE__*/_createVNode("span", null, "查看")
], -1)
const _hoisted_14 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_15 = { class: "detail-wrapper" }
const _hoisted_16 = { class: "person-intro-container" }
const _hoisted_17 = { class: "top-container" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "减重", -1)
const _hoisted_20 = { class: "weight" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "kg", -1)
const _hoisted_22 = { class: "bottom-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotLogoTips = _resolveComponent("HotspotLogoTips")
  const _component_HotspotSwiper = _resolveComponent("HotspotSwiper")
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.intro, (i, k) => {
                  return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                }), 128))
              ]),
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
                  return (_openBlock(), _createBlock("div", {
                    key: k,
                    class: "content-item",
                    onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
                  }, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("img", {
                        src: i.cover
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode("span", _hoisted_9, _toDisplayString(i.weight), 1),
                        _hoisted_10
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("span", null, _toDisplayString(i.name), 1)
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _createVNode("span", null, _toDisplayString(i.desc), 1)
                      ]),
                      _hoisted_13
                    ])
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _createVNode(_component_HotspotLogoTips, {
                text: _ctx.modules.logoTips,
                onAction: _ctx.goZsPage
              }, null, 8, ["text", "onAction"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail && _ctx.modules.list[_ctx.currentIndex].detail)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_HotspotSwiper, {
                  list: _ctx.modules.list[_ctx.currentIndex].detail.swiper,
                  onAudiobgstop: _ctx.audiobgstop
                }, null, 8, ["list", "onAudiobgstop"]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].name), 1),
                    _hoisted_19,
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].weight), 1),
                    _hoisted_21
                  ]),
                  _createVNode("div", _hoisted_22, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.personIntro, (i, k) => {
                      return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_HotspotContentList, {
                  list: _ctx.modules.list[_ctx.currentIndex].detail.list,
                  onAudiobgstop: _ctx.audiobgstop
                }, null, 8, ["list", "onAudiobgstop"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})